import { Button, Input } from '@/components/ui';
import type { FilterOperator } from '@shared/types';
import { X } from 'lucide-react';
import { type QueryConditionRowProps, useQueryConditionRow } from './use-query-condition-row';

export function QueryConditionRow(props: QueryConditionRowProps) {
  const f = useQueryConditionRow(props);

  return (
    <div className="flex gap-2 items-center">
      <div className="flex-1 grid grid-cols-3 gap-2">
        <select
          value={f.condition.field}
          onChange={(e) => f.handleFieldChange(e.target.value)}
          className="flex h-9 w-full cursor-pointer rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
        >
          <option value="">Select field</option>
          {f.availableFields.map((field) => (
            <option key={field} value={field}>
              {field === '__id__' ? 'Document ID' : field}
            </option>
          ))}
        </select>

        <select
          value={f.condition.operator}
          onChange={(e) => f.handleOperatorChange(e.target.value as FilterOperator)}
          className="flex h-9 w-full cursor-pointer rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
        >
          {f.operators.map((op) => (
            <option key={op.value} value={op.value}>
              {op.label}
            </option>
          ))}
        </select>

        <Input
          type="text"
          value={f.valueDisplay}
          onChange={(e) => f.handleValueChange(e.target.value)}
          placeholder={f.isArrayOperator ? '["value1", "value2"]' : 'Value'}
          className="text-sm"
        />
      </div>

      <Button
        type="button"
        variant="ghost"
        size="icon"
        onClick={f.handleRemove}
        className="h-9 w-9"
      >
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
}
